import api from '@/utils/api'

export default {
    createMembership(data) {
        return api.post(`user-memberships`, data)
    },
    getMembership(userMembershipId) {
        return api.get(`user-memberships/${userMembershipId}`)
    },
    getMemberships(params) {
        if (!params || Object.keys(params).length === 0) {
            return api.get(`user-memberships`)
        }
        return api.get(`user-memberships`, {
            params: {
                filter: JSON.stringify(params)
            }
        })
    },
    updateMembership(userMembershipId, data) {
        return api.put(`user-memberships/${userMembershipId}`, data)
    }
}
